//
// Copyright (c) 2025 Comcast
//

import PropTypes from 'prop-types'
import { useState } from 'react'

import SidebarSection from 'components/Shared/Sidebar/SidebarSection/Index'
import SidebarText from 'components/Shared/Sidebar/SidebarText/Index'

const MAX_FIELD_LENGTH = 350

const SidebarSectionSecureText = ({ title, tooltipText, value, isSecure, markedPart }) => {
  const [secureFieldsVisibility, setSecureFieldsVisibility] = useState(false)

  const triggreSecureFieldVisibility = () => {
    setSecureFieldsVisibility(!secureFieldsVisibility)
  }

  const getFieldText = () => {
    if (!isSecure) {
      return value
    }

    return secureFieldsVisibility ? value : value.toString().replace(/./g, '•')
  }

  const showSecureIcon = Boolean(value && isSecure)

  return (
    <SidebarSection
      title={title}
      tooltipText={tooltipText}
      copyText={value}
      showSecureIcon={showSecureIcon}
      secureIconState={secureFieldsVisibility}
      secureIconOnClick={() => { triggreSecureFieldVisibility() }}
    >
      <SidebarText
        text={getFieldText()}
        markedPart={markedPart}
        truncateLength={MAX_FIELD_LENGTH}
      />
    </SidebarSection>
  )
}

SidebarSectionSecureText.propTypes = {
  title: PropTypes.string,
  tooltipText: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isSecure: PropTypes.bool,
  markedPart: PropTypes.string,
}

export default SidebarSectionSecureText
